import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, FileText, ChevronLeft } from 'lucide-react';

export const LegalTermsPage: React.FC = () => {
  return (
    <div className="space-y-12 py-12 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      
      <div>
        <Link to="/" className="inline-flex items-center gap-1.5 text-xs font-bold text-slate-500 hover:text-editorial-dark">
          <ChevronLeft className="w-4 h-4" />
          <span>Home</span>
        </Link>
      </div>

      <div className="space-y-4">
        <span className="text-xs font-mono uppercase tracking-widest text-brand-700 font-bold">
          Legal &amp; Business Information
        </span>
        <h1 className="text-3xl sm:text-4xl font-serif font-bold text-editorial-dark">
          Publishing Terms, Privacy &amp; Copyright Policy
        </h1>
        <p className="text-sm text-slate-600 font-mono">
          Last Updated: 2026-03-01 &bull; For The Truth Publishing
        </p>
      </div>

      <div className="p-8 sm:p-10 rounded-2xl bg-white border border-editorial-border shadow-xs space-y-8 text-xs sm:text-sm text-slate-700 leading-relaxed font-sans">
        <section className="space-y-3">
          <h2 className="font-serif text-lg font-bold text-slate-900">1. Intellectual Property &amp; Author Ownership</h2>
          <p>Authors retain all foundational copyright in and to their manuscripts unless explicitly assigned through a formal bespoke publishing agreement. For The Truth Publishing acts as publisher, producer, and distributor according to agreed contractual schedules.</p>
        </section>

        <section className="space-y-3">
          <h2 className="font-serif text-lg font-bold text-slate-900">2. Editorial Discretion &amp; Quality Control</h2>
          <p>For The Truth Publishing exercises strict editorial standards. All submissions undergo doctrinal review, developmental evaluation, and proofing. We reserve the right to recommend revisions necessary to preserve theological clarity and grammatical rigor.</p>
        </section>

        <section className="space-y-3">
          <h2 className="font-serif text-lg font-bold text-slate-900">3. Confidentiality &amp; Data Security</h2>
          <p>Manuscripts, synopsis files, and proposals submitted through our Publishing Enquiry System or Client Portal are treated with strict confidentiality. Files are stored within encrypted storage environments and accessible exclusively by assigned staff editors and authorized clients.</p>
        </section>

        <section className="space-y-3">
          <h2 className="font-serif text-lg font-bold text-slate-900">4. Ecosystem Separation Statement</h2>
          <p>For The Truth Publishing is an autonomous publishing business unit. It functions in strategic partnership with the For The Truth Bookstore for retail distribution, but maintains independent operational accounting, client contracts, and editorial oversight.</p>
        </section>
      </div>

    </div>
  );
};
